export default __webpack_public_path__ + "static/media/sdg.7fa0731b.png";